import axios from "axios";
import { JWT } from "../shared";
import { API_ENDPOINTS } from "./EndPoints";
import { ResponseEnum } from "./ResponseEnum";

const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const accessToken = localStorage.getItem("accessToken");
if (accessToken) {
  JWT.setJwt(accessToken);
}

//  Check if user exists
export const userExists = async () => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.USER_EXISTS}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });


    return response.data;

  } catch (error) {
    if (error.response?.status === 404) {
      return { success: false, message: "User not found", data: null };
    }

    console.error("userExists API error:", error);
    return { success: false, message: "Server error", data: null };
  }
};

export const userCreate = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.USER_CREATE}`;

    const response = await axios.post(url, data, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("userCreate API error:", error);
    return { success: false, message: "Failed to create user" };
  }
};

// GET_PROFILE

export const getSignedGetProfile = async () => {
  //  // eslint-disable-next-line no-debugger
  //  debugger;
  try {
    const accessToken = localStorage.getItem("accessToken");
    const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_PROFILE}`;
    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });
    if (response.data.success == ResponseEnum.SUCCESS) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

// GET_AGREEMENTS

export const GetAgreementsList = async (status, page = 1, limit = 5, search = "") => {
  try {
    const accessToken = localStorage.getItem("accessToken");

    const url = `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_AGREEMENTS}?status_filter=${status}&page=${page}&limit=${limit}&search=${search}`;

    console.log("GetAgreementsList URL:", url); // <-- add this for debugging

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("API ERROR => ", error);
    return Promise.reject(error);
  }
};

// SAVE_AGREEMENT

export const saveAgreement = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.SAVE_AGREEMENT}`;

    const formData = new FormData();

    // Basic fields
    formData.append("agreement_name", data.agreement_name);
    formData.append("status", data.status);
    formData.append("due_date", data.due_date);

    if (data.agreement_id) {
      formData.append("agreement_id", data.agreement_id);
    }

    // Recipients (MUST be JSON)
    formData.append("recipients", JSON.stringify(data.recipients));

    // Document metadata (NO binary)
    const documentMeta = data.documents.map(d => ({
      id: d.id || null,
      name: d.name,
      type: d.type,
      size: d.size,
      path: d.path || null,
      file_url: d.file_url || null
    }));

    formData.append("documents", JSON.stringify(documentMeta));

    // Binary file(s)
    data.documents.forEach((doc) => {
      if (doc.binary instanceof File) {
        formData.append("files", doc.binary, doc.name);
      }
    });

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response.data;

  } catch (error) {
    console.error("saveAgreement API error:", error);
    return { success: false, message: "Failed to save agreement" };
  }
};

// DELETE_ID_CANCELLED

export const cancelAgreement = async (agreementId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const cleanBase = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.DELETE_ID_CANCELLED}`.replace(/\/+$/, "");
    const url = `${cleanBase}/${agreementId}`;

    const response = await axios.put(
      url,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("cancelAgreement API error:", error);
    return { success: false, message: "Failed to cancel agreement" };
  }
};

// GET_DASHBOARD

export const GetDashboardList = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");

    const url = `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_DASHBOARD}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      }
    });

    return response.data;
  } catch (error) {
    console.error("API ERROR => ", error);
    return Promise.reject(error);
  }
};

// GET_USER_INFO
export const getUserInfo = async (search = "") => {
  try {
    const token = localStorage.getItem("accessToken");

    //  Correct: use API_ENDPOINTS, NOT direct URL
    const url = `${process.env.REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_RECIPIENT}?search=${encodeURIComponent(search)}`;

    console.log(" Calling user search API:", url);

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    // new API returns array directly
    if (!response?.data?.success || !Array.isArray(response.data.data)) {
      return { success: false, data: [] };
    }

    // normalize results
    const users = response.data.data.map((u) => ({
      firstName: u.firstName || "",
      lastName: u.surname || "",
      displayName: u.displayName || "",
      email: u.emailID || "",
    }));

    return { success: true, data: users };
  } catch (err) {
    console.error(" getUserInfo ERROR:", err);
    return { success: false, data: [] };
  }
};

// GET_EDIT_AGREEMENT_BY_ID
export const getEditAgreementById = async (agreementId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const cleanBase = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_EDIT_AGREEMENTS_ID}`.replace(/\/+$/, "");
    const url = `${cleanBase}/${agreementId}`;

    const response = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("getEditAgreementById API error:", error);
    return { success: false, message: "Failed to fetch agreement details", data: null };
  }
};

// SEND AGREEMENT
export const sendAgreement = async (data) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.SEND_AGREEMENT_RECIPIENT}`;

    const formData = new FormData();

    // formData.append("agreement_id", data.agreement_id);
    formData.append("agreement_name", data.agreement_name);
    formData.append("status", "in_progress");
    formData.append("due_date", data.due_date);
    formData.append("recipients", JSON.stringify(data.recipients));
    if (data.agreement_id) {
      formData.append("agreement_id", data.agreement_id);
    }

    const normalizeValue = (v) => {
      if (v === undefined || v === "" || v === "null") return null;
      return v;
    };

    // Document metadata
    formData.append("documents", JSON.stringify(
      data.documents.map(d => ({
        id: normalizeValue(d.id),
        name: d.name,
        type: d.type,
        size: d.size,
        path: d.path || null,
        file_url: d.file_url || null
      }))
    ));

    // Binary Files
    data.documents.forEach((doc) => {
      if (doc.binary instanceof File) {
        formData.append("files", doc.binary, doc.name);
      }
    });

    const response = await axios.post(url, formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("sendAgreement API error:", error);
    return { success: false, message: "Failed to send agreement" };
  }
};
// /Download 
export const downloadAgreementFile = async (agreementId) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_DOWNLOAD_DOCUMENT}/${agreementId}`;

    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    const docs = response?.data?.data?.documents;
    if (!docs || docs.length === 0) return null;

    return docs[0].download_url;  // return file URL

  } catch (error) {
    console.error("downloadAgreementFile error:", error);
    return null;
  }
};

export const previewAgreement = async (agreementId) => {
  const url = `${REACT_APP_API_BASE_URL}${API_ENDPOINTS.GET_PREVIEW_DOCUMENT}/${agreementId}`;

  console.log("[previewAgreement] called with id:", agreementId);
  console.log("[previewAgreement] url:", url);

  try {
    const token = localStorage.getItem("accessToken");
    console.log("[previewAgreement] token exists:", !!token);

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("[previewAgreement] API RESPONSE:", response.data);

    return response.data;
  } catch (error) {
    console.error("[previewAgreement] API ERROR:", error);
    console.error("[previewAgreement] error.response:", error?.response);

    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Preview not available",
    };
  }
};